import Client from './client';

export default class InventoryOrganizationSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/inventory/settings`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/inventory/settings`, {
      ...options,
       method: 'POST',
    });
  }

  put(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/inventory/settings`, {
      ...options,
       method: 'PUT',
    });
  }

  delete(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/inventory/settings`, {
      ...options,
       method: 'DELETE',
    });
  }

}
